<template>
  <site-header>
    <h1 class="mb-8 text-[2.5rem] font-bold uppercase text-white">
      Nos services<br />
    </h1>
    <search-routes class="left-5 right-5 max-md:absolute"></search-routes>
  </site-header>

  <section-wrapper class="bg-background-3 max-md:pt-[14rem]">
    <img
      src="/images/nos-services-1.png"
      alt="Nos services"
      class="absolute left-[50%] top-0 z-[1] ml-[8rem] hidden xl:block"
    />
    <section-container
      id="mise-en-relation"
      mobile-padding
      class="max-w-container prose-funargos prose relative z-[1] grid-cols-2 gap-10 py-20 lg:py-32 xl:grid"
    >
      <div>
        <section-title
          >Mise en relation<br />des chauffeurs funéraires</section-title
        >

        <p>
          Ne réalisez plus de trajets “à vide” lors de vos transports
          funéraires, qu’ils soient de courte ou de longue distance !
        </p>
        <p>
          Soyez connectés en étant offreur ou demandeur, en toute sécurité et en
          temps réel - 24h/24 - 7j/7 - aux autres membres de la communauté
          FUNARGOS et devenez alors un opérateur responsable et engagé !
        </p>
        <p>
          Soyez acteur de ces connexions entre professionnels du funéraire qui
          vous permettront d’optimiser votre travail, votre temps et surtout vos
          déplacements !
        </p>
        <p>
          N’attendez plus, rejoignez facilement notre plateforme pour commencer
          à publier vos trajets effectués “à vide” ou à chercher des transports
          disponibles pour vos défunts. Vous pourriez simplement passer à côté
          de belles opportunités !
        </p>
      </div>

      <div class="flex items-center justify-center">
        <img
          src="/images/nos-services-1.png"
          alt="Nos services"
          class="w-[32rem] xl:hidden"
        />
      </div>
    </section-container>
    <div class="max-w-container relative mx-auto">
      <svg
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 2235.67 163.73"
        fill="currentColor"
        class="text-background-3 absolute -left-[130rem] bottom-0 h-[25rem] bg-white"
      >
        <path
          d="m.63,0l-.63,36.5h758.65v-10.9c0-2.49,2.02-4.51,4.51-4.51,1.12,0,2.19.41,3.02,1.16l32.89,29.57c5.29,4.75,5.73,12.89.98,18.18-.31.34-.64.67-.98.98l-32.89,29.57c-1.86,1.66-4.71,1.51-6.37-.35-.74-.83-1.15-1.9-1.15-3,0,0,0-6.63-.04-6.63v-8.03c0-1.69-1.35-3.06-3.04-3.07-.76,0-1.49.27-2.05.78l-11.46,10.31-1.02.91-25.39,22.84c-4.02,3.62-4.35,9.81-.74,13.84.23.26.48.5.74.73l25.39,22.82,1.74,1.56,10.75,9.66c1.24,1.13,3.16,1.04,4.3-.2.52-.57.8-1.3.79-2.07v-12.31h1477.06V0H.63Z"
        />
      </svg>
    </div>
  </section-wrapper>

  <section-wrapper class="bg-white">
    <img
      src="/images/nos-services-2.png"
      alt="Nos services"
      class="absolute right-[50%] top-20 z-[1] ml-[8rem] hidden xl:block"
    />
    <section-container
      id="fonctionnement-des-services"
      mobile-padding
      class="max-w-container prose-funargos prose relative z-[1] grid-cols-2 gap-10 py-20 lg:py-32 xl:grid"
    >
      <div></div>
      <div>
        <section-title>Fonctionnement des services</section-title>

        <p>
          Aucune inquiétude, tout est conçu et pensé pour faciliter votre
          expérience FUNARGOS !
        </p>

        <p>Vous roulez « à vide » ? Vous cherchez un défunt à transporter ?</p>

        <p>
          Quoi de plus simple que d’indiquer votre lieu et heure de départ,
          votre lieu d’arrivée et vos tarifs pour être directement réservé par
          un autre confrère ayant besoin de votre service !
        </p>
        <p>Autre point de vue… Vous avez un défunt à transporter ?</p>
        <p>
          Entrez simplement vos critères de lieux et d’heures sur la plateforme,
          nous vous proposerons l’ensemble des trajets disponibles à la
          réservation ! Vous n’aurez plus qu’à réserver celui qui correspondra
          au mieux à votre demande.
        </p>
        <p>
          Soyez attentifs aux critères que vous inscrirez dans chacun des
          champs, chaque information est importante pour cibler votre demande et
          vous afficher des propositions de qualité !
        </p>
        <p>
          Soyez rassurés, FUNARGOS se charge également de l’aspect financier,
          des transactions bancaires et des transmissions de factures entre
          confrères. Ne craignez pas les impayés, FUNARGOS vous assure le
          paiement des prestations effectuées !
        </p>
      </div>

      <div class="flex items-center justify-center">
        <img
          src="/images/nos-services-2.png"
          alt="Nos services"
          class="w-[32rem] xl:hidden"
        />
      </div>
    </section-container>
    <div class="max-w-container relative mx-auto">
      <svg
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 2235.67 163.73"
        fill="currentColor"
        class="bg-background-3 absolute -left-[130rem] bottom-0 h-[25rem] text-white"
      >
        <path
          d="m.63,0l-.63,36.5h758.65v-10.9c0-2.49,2.02-4.51,4.51-4.51,1.12,0,2.19.41,3.02,1.16l32.89,29.57c5.29,4.75,5.73,12.89.98,18.18-.31.34-.64.67-.98.98l-32.89,29.57c-1.86,1.66-4.71,1.51-6.37-.35-.74-.83-1.15-1.9-1.15-3,0,0,0-6.63-.04-6.63v-8.03c0-1.69-1.35-3.06-3.04-3.07-.76,0-1.49.27-2.05.78l-11.46,10.31-1.02.91-25.39,22.84c-4.02,3.62-4.35,9.81-.74,13.84.23.26.48.5.74.73l25.39,22.82,1.74,1.56,10.75,9.66c1.24,1.13,3.16,1.04,4.3-.2.52-.57.8-1.3.79-2.07v-12.31h1477.06V0H.63Z"
        />
      </svg>
    </div>
  </section-wrapper>

  <section-wrapper class="bg-background-3 mb-24">
    <img
      src="/images/nos-services-3.png"
      alt="Nos services"
      class="absolute left-[50%] top-0 z-[1] ml-[8rem] hidden xl:block"
    />
    <section-container
      id="nos-offres"
      mobile-padding
      class="max-w-container prose-funargos prose relative z-[1] grid-cols-2 gap-10 py-20 lg:py-32 xl:grid"
    >
      <div>
        <section-title>Découvrir nos offres</section-title>

        <p class="font-semibold">
          • Découvrez nos offres sans abonnement et uniquement basées sur les
          performances !
        </p>
        <p>
          • Chez FUNARGOS, nous avons une approche unique, complète et
          transparente. Contrairement à d’autres services, nous ne vous
          facturons pas d’abonnement mensuel ou annuel. Nous croyons en la
          récompense des résultats concrets, c’est pourquoi nous prenons une
          commission sur les montants des transports que vous effectuez.
        </p>
        <p>
          Notre objectif est de créer une communauté où tout le monde est
          gagnant.
        </p>
        <p class="font-semibold">• Si vous êtes chauffeur transporteur</p>
        <p>
          Vous serez rémunéré pour les trajets que vous effectuez en plus de vos
          transports initiaux
        </p>
        <p class="font-semibold">
          • Si vous êtes un chauffeur proposant un corps à transporter ?
        </p>
        <p>
          Vous ne paierez que les kilomètres réellement effectués, sans les
          frais d’un aller-retour inutile.
        </p>
        <p>
          Découvrez nos offres dès maintenant et rejoignez notre communauté de
          manière totalement transparente et équitable !
        </p>
      </div>

      <div class="flex items-center justify-center">
        <img
          src="/images/nos-services-3.png"
          alt="Nos services"
          class="w-[32rem] xl:hidden"
        />
      </div>
    </section-container>
    <div class="max-w-container relative mx-auto">
      <svg
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 2235.67 163.73"
        fill="currentColor"
        class="text-background-3 absolute -left-[130rem] bottom-0 h-[25rem] bg-white"
      >
        <path
          d="m.63,0l-.63,36.5h758.65v-10.9c0-2.49,2.02-4.51,4.51-4.51,1.12,0,2.19.41,3.02,1.16l32.89,29.57c5.29,4.75,5.73,12.89.98,18.18-.31.34-.64.67-.98.98l-32.89,29.57c-1.86,1.66-4.71,1.51-6.37-.35-.74-.83-1.15-1.9-1.15-3,0,0,0-6.63-.04-6.63v-8.03c0-1.69-1.35-3.06-3.04-3.07-.76,0-1.49.27-2.05.78l-11.46,10.31-1.02.91-25.39,22.84c-4.02,3.62-4.35,9.81-.74,13.84.23.26.48.5.74.73l25.39,22.82,1.74,1.56,10.75,9.66c1.24,1.13,3.16,1.04,4.3-.2.52-.57.8-1.3.79-2.07v-12.31h1477.06V0H.63Z"
        />
      </svg>
    </div>
  </section-wrapper>
</template>
<script setup></script>
